import { useState } from 'react';

let count = 0;

export const useIdCounter = (prefix = '') => {
  const [counter] = useState(() => count++);

  return [prefix, `${counter}`].filter(Boolean).join('-');
};
